export type Rgb = readonly [number, number, number];

/** A colour ramp: ascending values, each with the colour it maps to. */
export type ColorStops = readonly (readonly [value: number, color: Rgb])[];

/** Linear interpolation along the ramp; values outside it take the end colours. */
export function interpolateColor(stops: ColorStops, value: number): Rgb {
  if (value <= stops[0][0]) return stops[0][1];
  for (let k = 1; k < stops.length; k++) {
    const [v1, c1] = stops[k];
    const [v0, c0] = stops[k - 1];
    if (value <= v1) {
      const t = (value - v0) / (v1 - v0);
      return [c0[0] + (c1[0] - c0[0]) * t, c0[1] + (c1[1] - c0[1]) * t, c0[2] + (c1[2] - c0[2]) * t];
    }
  }
  return stops[stops.length - 1][1];
}

export const rgbCss = ([r, g, b]: Rgb) => `rgb(${r}, ${g}, ${b})`;
